"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const SnowplowProvider_1 = __importDefault(require("./SnowplowProvider"));
const snowplow_js_common_1 = require("@angi/snowplow-js-common");
const googleTagManager_1 = __importDefault(require("./googleTagManager"));
/**
 * React Element for implementing Snowplow
 *
 * @param props all required and optional props for the Tracker initialization
 */
const Snowplow = ({ configuration, children }) => {
    (0, react_1.useEffect)(() => {
        return () => {
            (0, snowplow_js_common_1.clearGlobalContexts)();
        };
    }, []);
    const { googleTagManagerConfiguration } = configuration;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (googleTagManagerConfiguration === null || googleTagManagerConfiguration === void 0 ? void 0 : googleTagManagerConfiguration.enabled) && (react_1.default.createElement(googleTagManager_1.default, { isProApp: googleTagManagerConfiguration === null || googleTagManagerConfiguration === void 0 ? void 0 : googleTagManagerConfiguration.isProApp })),
        react_1.default.createElement(SnowplowProvider_1.default, { configuration: configuration }, children)));
};
exports.default = Snowplow;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU25vd3Bsb3cuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvcmVhY3QvU25vd3Bsb3cudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQ0FBeUM7QUFHekMsMEVBQWtEO0FBQ2xELGlFQUErRDtBQUMvRCwwRUFBZ0U7QUFFaEU7Ozs7R0FJRztBQUNILE1BQU0sUUFBUSxHQUFHLENBQUMsRUFBRSxhQUFhLEVBQUUsUUFBUSxFQUFpQixFQUFnQixFQUFFO0lBQzFFLElBQUEsaUJBQVMsRUFBQyxHQUFHLEVBQUU7UUFDWCxPQUFPLEdBQUcsRUFBRTtZQUNSLElBQUEsd0NBQW1CLEdBQUUsQ0FBQztRQUMxQixDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFFUCxNQUFNLEVBQUUsNkJBQTZCLEVBQUUsR0FBRyxhQUFhLENBQUM7SUFFeEQsT0FBTyxDQUNIO1FBQ0ssQ0FBQSw2QkFBNkIsYUFBN0IsNkJBQTZCLHVCQUE3Qiw2QkFBNkIsQ0FBRSxPQUFPLEtBQUksQ0FDdkMsOEJBQUMsMEJBQThCLElBQzNCLFFBQVEsRUFBRSw2QkFBNkIsYUFBN0IsNkJBQTZCLHVCQUE3Qiw2QkFBNkIsQ0FBRSxRQUFRLEdBQ25ELENBQ0w7UUFDRCw4QkFBQywwQkFBZ0IsSUFBQyxhQUFhLEVBQUUsYUFBYSxJQUFHLFFBQVEsQ0FBb0IsQ0FDOUUsQ0FDTixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUsUUFBUSxDQUFDIn0=


// WEBPACK FOOTER //
// ../../../src/react/Snowplow.tsx